import { render, staticRenderFns } from "./ArticleFormCreate.vue?vue&type=template&id=8a4e4468&"
import script from "./ArticleFormCreate.vue?vue&type=script&lang=js&"
export * from "./ArticleFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports